import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { BANK_CONNECTION_STATUS } from 'src/services/mappings/bankConnection/bankConnection.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const bankConnectionFields: FieldInterface[] = [
  {
    key: 'accountId',
    originKey: 'account_id',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'bankName',
    originKey: 'bank_name',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'status',
    originKey: 'status',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
    enumKeys: Object.values(BANK_CONNECTION_STATUS),
  },
  {
    key: 'portfolios',
    originKey: 'portfolios',
    type: FIELD_TYPES.object,
    objectType: 'IdOnlyModel',
    objectTypePath: 'src/global-types',
    rule: FIELD_RULES.isReadOnly,
    isMultiple: true,
  },
]

const bankConnectionRelations: RelationInterface[] = []

export { bankConnectionFields, bankConnectionRelations }
